import { ComponentType, ReactNode, Suspense, lazy } from 'react'
import { RouteObject } from 'react-router'

import AuthTheme from '../pages/auth/authBrand'

import SuspenseLoader from '../components/SuspenseLoader'

const Loader =
  <P extends object>(Component: ComponentType<P>) =>
  (props: P): ReactNode =>
    (
      <Suspense fallback={<SuspenseLoader />}>
        <Component {...props} />
      </Suspense>
    )

const MobileOnly = Loader(lazy(() => import('../pages/auth/mobileOnly')))

/**
 * FB-8 — routes for a signed-in `client`. The web client (onboarding,
 * dagboek, kalender, statistieken, chat) is retired; clients use the
 * mobile app. Every path collapses to one page that says so and offers
 * the data export + logout, so old bookmarks can't reach a dead tree.
 */
const routesMobileOnly: RouteObject[] = [
  {
    path: '*',
    element: (
      <AuthTheme>
        <MobileOnly />
      </AuthTheme>
    ),
  },
]

export default routesMobileOnly
